<!-- <div class="modal fade show" id="raisoni-previlege" aria-labelledby="ModalOneLabel" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close cls-btn" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/emailer/web-banner-raisoni-privilege.jpg" alt="Raisoni Privilege" class="img-fluid">
            </div>
        </div>
        </div>
    </div> -->
<section class="home-slider">
    <div class="swiper swiper-home-slide">
        <div class="swiper-wrapper">
            <div class="swiper-slide img-fluid"
                style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/banner/banner.webp);">

            </div>
            <div class="swiper-slide img-fluid"
                style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/banner/banner1.webp);">

            </div>
            <div class="swiper-slide img-fluid"
                style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/banner/banner2.webp);">

            </div>
            <div class="swiper-slide img-fluid"
                style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/banner/banner3.webp);">

            </div>
            <div class="swiper-slide img-fluid"
                style="background-image: url(https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/banner/banner4.webp);">
            </div>
        </div>
        <div class="breadcrumb-bottom-img">
            <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
                alt="GHRSCF" />
        </div>
    </div>
</section>
<section class="section section-sm section-bg-banner upcoming-event" id="upcoming_events">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>Upcoming Events</span></h2>
            <p class="text-center">Sports & Cultural</p>
        </div>
        <!-- </div> -->
        <div class="row justify-content-center align-items-center">
            <div class="col-md-11">
                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/chess--2.webp"
                                alt=" Badminton Tournament | GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold"> G. H. Raisoni Memorial & H2E Power Systems Maharashtra State Under-11
                                Open and Girls Selection FIDE Rated Chess Championships 2026</h4>
                            <h6 class="fw-bold">10<sup>th</sup> July – 12<sup>th</sup> July 2026</h6>
                            <p><strong>Name:</strong> G H raisoni Memorial Surguja Divisional Selection Chess Tournament
                                -2026, Ambikapur CG</p>
                            <p><strong> Date:</strong> 19th July- 2026</p>
                            <p><strong> Organized By:</strong>Creative Chess Association, Chandrapur</p>
                            <p><strong> Venue:</strong> Janta Mahavidyalaya (Janta College), Nagpur Road, Chandrapur</p>
                            <span class="date-event-up">July 2026 </span>
                            <div class="d-flex justify-content-start mr-5">
                                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/state-11-sel-chand.pdf"
                                    target="_blank" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/chess--1.webp"
                                alt=" Badminton Tournament | GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold"> G H raisoni Memorial Surguja Divisional Selection Chess Tournament
                                -2026, Ambikapur CG</h4>
                            <h6 class="fw-bold">19<sup>th</sup> July 2026</h6>

                            <p><strong> Organized By:</strong> Shatranj Sangh Surguja In Association With G H Raisoni
                                sports and cultural
                                Foundation & Kalpana Prakash Welfare Foundation</p>
                            <p><strong> Venue:</strong> Ambikapur Chhattisgarh</p>
                            <span class="date-event-up">July 2026 </span>
                            <div class="d-flex justify-content-start mr-5">
                                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/surguja-div-sel-event-19-july-26.pdf"
                                    target="_blank" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->



                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2026/nanded.webp"
                                alt=" Badminton Tournament | GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold">Yonex-Sunrise G H Raisoni Memorial Ahilyanagar District Badminton
                                Championship 2026 </h4>
                            <h6 class="fw-bold">19<sup>th</sup>to
                                21<sup>th</sup> June 2026 </h6>
                            <p>Yonex-Sunrise G H Raisoni Memorial Ahilyanagar District

                                Badminton Championship 2026

                                organised by

                                ahmednagar district badminton association

                                Affiliated to Maharashtra Badminton Association</p>
                            <span class="date-event-up">June 2026 </span>
                            <div class="d-flex justify-content-start mr-5">
                                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2026/circular-adba-19th-21th-june.pdf"
                                    target="_blank" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->



                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2026/amrawati.webp"
                                alt=" Badminton Tournament | GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold"> G. H. Raisoni Memorial Badminton Tournament Amravati </h4>
                            <h6 class="fw-bold">06<sup>th</sup> to
                                07<sup>th</sup> June 2026 </h6>

                            <span class="date-event-up">June 2026 </span>
                            <div class="d-flex justify-content-start mr-5">
                                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-2026/mpba-u-19-cir-26-khargone-26.pdf"
                                    target="_blank" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/nanded-district-bad-champ-25-poster.webp"
                                alt="21st Nanded District Badminton Championship | Ghrscf" />
                        </div>
                        <div class="col-md-8 up-event-text mt-3">
                            <h4 class="fw-bold"> Yonex-Sunrise G H Raisoni Memorial 21st Nanded District Badminton
                                Championship - 2025
                            </h4>
                            <p>
                                DATE : 9th - 10 th August - 2025
                            </p>
                            <span class="date-event-up">August 2025</span>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/thane-one-day-rapid-chess-tournament.webp"
                                alt="One Day Rapid Chess Tournament | Ghrscf" />
                        </div>
                        <div class="col-md-8 up-event-text mt-3">
                            <h4 class="fw-bold"> G H Raisoni Memorial Thana One Day Rapid Chess Tournament
                            </h4>
                            <p>
                                DATE : 10th August 2025
                            </p>

                            <span class="date-event-up">August 2025</span>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="up-event" *ngIf="showContent">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/swaragini.webp"
                                alt="एक शाम गीतों के नाम | Ghrscf" />
                        </div>
                        <div class="col-md-8 up-event-text mt-3">
                            <h4 class="fw-bold"> एक शाम गीतों के नाम - "स्वर - स्वरांगिनी"
                            </h4>
                            <p>
                                DATE : 02 August 2025
                            </p>
                            <p>
                                TIME : 6:00 PM
                            </p>
                            <p>
                               VENUE : Banyan Hall, Chitnavis Centre, Civil Lines, Nagpur – 440001
                            </p>
                                 <div class="d-flex justify-content-start">
                                <a routerLink="/swaragini" class="cmn-button">Register Now</a>
                            </div>
                            <span class="date-event-up">August 2025</span>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/upcoming-events/mpba-badminton.webp"
                                alt="NEEV - EMPLOYEE SPORTS |  GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text mt-3">
                            <h4 class="fw-bold">G. H. RAISONI MEMORIAL MADHYA PRADESH STATE JUNIOR RANKING

                                BADMINTON TOURNAMENT 2025 Prize Money Rs.2 Lac</h4>

                            <p>Madhya Pradesh Badminton Association and Sunrise-Yonex Olympus Badminton Academy, Indore
                                is jointly
                                organizing the “G. H. Raisoni Memorial Madhya Pradesh State Junior (Under 17 & 19 age
                                group) </p>
                            <span class="date-event-up">05th October 2025</span>
                            <div class="d-flex justify-content-start">
                                <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/mpba-u-17-19-circu-25-indore.pdf"
                                    target="_blank" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak.jpg"
                                alt="karandak  |  GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold">जी.एच. रायसोनी करंडक
                                2027</h4>
                            <!-- <h6 class="fw-bold">1<sup>st</sup> and
                                4<sup>th</sup> February 2025</h6> -->
                            <p>
                                जी.एच. रायसोनी स्पोर्ट्स अँड कल्चरल
                                फाउंडेशनच्या माध्यमातून नाट्य क्षेत्रातील
                                छोटे-मोठे उपक्रम आयोजित करण्यात आले.
                                ख्यातनाम कलावंतांच्या मुलाखती आयोजित केल्या.
                                पण तरीही कुठेतरी उणीव जाणवत होती. प्रत्येक
                                उपक्रम हा नव्या पिढीला खुणावणारा, जोडणारा
                                असावा, यासाठी आमचे प्रयत्न राहिले आहे.
                                त्यानुसार राज्यस्तरीय आंतरमहाविद्यालयीन
                                एकांकिका स्पर्धा आयोजित करण्याचा निर्णय
                                आम्ही यावर्षी घेतला.
                            </p>
                            <span class="date-event-up">February 2027</span>
                            <div class="d-flex justify-content-start mr-5">
                                <a href="https://ghraisonikarandak.com/" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="up-event">
                    <div class="row">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-2026.avif"
                                alt="NEEV - EMPLOYEE SPORTS |  GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text mt-3">
                            <h4 class="fw-bold">22nd Employee Annual Sports & Cultural Meet </h4>

                            <p>
                                Every year in the month of Jan. 3 day’s
                                Annual sports and cultural event is
                                organized for the employees where all
                                teaching and non-teaching staff does
                                participate in the sports. It is also one of
                                many such
                                events organized by RGI
                            </p>
                            <span class="date-event-up">January 2027 </span>
                            <div class="d-flex justify-content-start">
                                <a routerLink="/employee-sport-meet" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="up-event">
                    <div class="row mt-3">
                        <div class="col-md-4">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/summer-camp3.webp"
                                alt="KITE FESTIVAL  |  GHRSCF" />
                        </div>
                        <div class="col-md-8 up-event-text">
                            <h4 class="fw-bold">KITE FESTIVAL</h4>
                            <!-- <h6 class="fw-bold">15<sup>th</sup> January
                                2025</h6> -->
                            <p>Every January with the reason of Makar
                                Sankranti fun happens in RGI. On the
                                promising Celebration of Uttarayan, We
                                organize “Kite-flying” celebration
                                exceptionally.</p>
                            <span class="date-event-up">January 2027</span>
                            <div class="d-flex justify-content-start mr-5">
                                <a routerLink="/kite-festival" class="cmn-button">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>

<!-- <section class="section-md campus-infra-sec">
        <div class="kimba-1">
            <img
                src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/kimba/kimba-1.png"
                alt="Kimba" />
        </div>
        <div class="container">
            <div class="sec-title text-center">
                <h2>Student <span>Life & Campus Infrastructure</span></h2>
                <p>Creating Spaces for Growth and Well-being</p>
            </div>
            <div class="grid-container">
                <div class="grid-item1">
                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/life.png"
                        alt="Campus" />
                </div>
                <div class="grid-item2 d-inline-block">
                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/sport.png"
                        alt="Campus" />

                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/lab.png"
                        alt="Campus" />

                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/bus.png"
                        alt="Campus" />
                </div>
                <div class="grid-item3">
                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/classroom.png"
                        alt="Campus" class="h-100" />
                </div>
                <div class="grid-item4">
                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/hostel.png"
                        alt="Campus" />

                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/library.png"
                        alt="Campus" />
                </div>
                <div class="grid-item5">
                    <img
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/campus-infra/campus.png"
                        alt="Campus" />
                </div>
            </div>
        </div>
    </section> -->
